import FontAwesomeIcon from "./FontAwesomeIcon";

export default function FilesIcon({ ...props }) {
  return <FontAwesomeIcon name="files-o" {...props} />;
}
